export * from './isMobile';
export { default } from './isMobile';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ismobilejs/esm/index.js
// module id = 406
// module chunks = 3